const Loading = () => {
  return (
    <>
      <div className="opacity-70 animate-skeleton w-full h-20 mb-16"></div>
      <div id="mp__skeleton-register">
        <div className="opacity-70 animate-skeleton flex flex-col justify-center items-center text-center mt-6 sm:mt-12 px-5 mb-16">
          <span className="opacity-70 animate-skeleton w-[8.313rem] h-8 mb-6"></span>
          <p className="opacity-70 animate-skeleton w-[48%] h-4 mb-1 rounded-sm"></p>
        </div>
        <section className="grid justify-center items-center max-w-2xl px-5 sm:px-24 mb-44 m-auto">
          <div className="relative py-3 max-w-screen-sm mx-auto">
            <label className="opacity-70 animate-skeleton block w-[2.063rem] h-[0.875rem] ml-4 mb-2.5"></label>
            <div className="opacity-70 animate-skeleton w-[29.375rem] h-12 rounded-lg max-[768px]:w-full"></div>
          </div>
          <div className="relative py-3 max-w-screen-sm mx-auto">
            <label className="opacity-70 animate-skeleton block w-[7.438rem] h-[0.875rem] ml-4 mb-2.5"></label>
            <div className="opacity-70 animate-skeleton w-[29.375rem] h-12 rounded-lg max-[768px]:w-full"></div>
          </div>
          <div className="relative py-3 grid sm:grid-cols-2 gap-3">
            <div>
              <label className="opacity-70 animate-skeleton block w-[2.688rem] h-[0.875rem] ml-4 mb-2.5"></label>
              <div className="opacity-70 animate-skeleton w-[14.188rem] h-12 rounded-lg max-[768px]:w-full"></div>
            </div>
            <div>
              <label className="opacity-70 animate-skeleton block w-[3.25rem] h-[0.875rem] ml-4 mb-2.5"></label>
              <div className="opacity-70 animate-skeleton w-[14.188rem] h-12 rounded-lg max-[768px]:w-full"></div>
            </div>
          </div>
          <div className="relative py-3 max-w-screen-sm mx-auto">
            <label className="opacity-70 animate-skeleton block w-8 h-[0.875rem] ml-4 mb-2.5"></label>
            <div className="opacity-70 animate-skeleton w-[29.375rem] h-12 rounded-lg max-[768px]:w-full"></div>
          </div>
          <div className="relative py-3 max-w-screen-sm mx-auto">
            <label className="opacity-70 animate-skeleton block w-[2.375rem] h-[0.875rem] ml-4 mb-2.5"></label>
            <div className="opacity-70 animate-skeleton w-[29.375rem] h-12 rounded-lg max-[768px]:w-full"></div>
          </div>
          <div className="max-w-screen-sm mx-auto">
            <div className="d-flex align-items-center">
              <div className="opacity-70 animate-skeleton w-[23.75rem] h-1 position-relative mr-3" />
              <span className="opacity-70 animate-skeleton w-[4.625rem] h-[0.875rem]"></span>
            </div>
          </div>
          <div className="max-w-screen-sm mt-6 mb-4">
            <div className="d-flex">
              <div className="opacity-70 animate-skeleton w-[8.375rem] h-2 position-relative mr-3" />
            </div>
          </div>
          <ul className="pl-0">
            <div className="flex items-center mb-2.5">
              <div className="opacity-70 animate-skeleton rounded-full w-3 h-3"></div>
              <div className="opacity-70 animate-skeleton w-[8.438rem] h-2 ml-[0.188rem]"></div>
            </div>
            <div className="flex items-center mb-2.5">
              <div className="opacity-70 animate-skeleton rounded-full w-3 h-3"></div>
              <div className="opacity-70 animate-skeleton w-48 h-2 ml-[0.188rem]"></div>
            </div>
            <div className="flex items-center mb-2.5">
              <div className="opacity-70 animate-skeleton rounded-full w-3 h-3"></div>
              <div className="opacity-70 animate-skeleton w-[26.375rem] h-2 ml-[0.188rem] max-[768px]:w-full"></div>
            </div>
            <div className="flex items-center">
              <div className="opacity-70 animate-skeleton rounded-full w-3 h-3"></div>
              <div className="opacity-70 animate-skeleton w-36 h-2 ml-[0.188rem]"></div>
            </div>
          </ul>
          <div className="flex items-center mt-[3.188rem]">
            <div className="opacity-70 animate-skeleton w-[1.125rem] h-[1.125rem] rounded-sm max-[375px]:w-[1.38rem] max-[768px]:w-[1.2rem] max-[768px]:h-4"></div>
            <div className="opacity-70 animate-skeleton ml-[0.438rem] w-[19.313rem] h-2 max-[425px]:w-full"></div>
          </div>
          <div className="mt-[3.188rem] flex justify-start max-w-screen-sm mx-auto">
            <div className="opacity-70 animate-skeleton w-[29.375rem] h-12 rounded-lg max-[768px]:w-full"></div>
          </div>
        </section>
      </div>
      <div className="opacity-70 animate-skeleton w-full h-[15.875rem] mt-[11.125rem]"></div>
    </>
  );
};

export default Loading;
